import * as auth from "./js/utils/auth";
import * as date from "./js/utils/date";
import * as hooks from "./js/utils/hooks";
import * as stringsImport from "./js/utils/strings";
import * as utils from "./js/utils/utils";
import * as common from "./js/utils/common";
import * as serviceUtils from "./js/services/utils";

// API Services
export {default as Services} from "./js/services/Services";
export {
  axiosInstance,
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest
} from "./js/services/api";

// General
export {default as Configuration} from "./js/Configuration";
export {default as Subscriptions} from "./js/Subscriptions";
export {default as Notifier} from "./js/Notifier";

// Localization
export {default as i18n} from "./js/localization/Localization";
export {generateBork} from "./js/localization/bork";
export {withTranslation} from './js/localization/withTranslation';

// Managers
export {
  default as CasebookManager,
  ManagerClass as CasebookManagerClass
} from "./js/services/casebook/Manager";
export {default as ExtensionManager} from "./js/services/extension/Manager";
export {default as IncidentManager} from "./js/services/incidents/Manager";
export {default as IndicatorManager} from "./js/services/indicators/Manager";
export {default as JudgementManager} from "./js/services/judgements/Manager";
export {default as NotificationManager} from "./js/services/notifications/Manager";
export {
  default as RegistryManager,
  ManagerClass as RegistryManagerClass
} from "./js/services/registry/Manager";
export {
  default as RelationshipManager,
  ManagerClass as RelationshipManagerClass
} from "./js/services/relationship/Manager";
export {default as SnapshotManager} from "./js/services/snapshots/Manager";
export {default as TelemetryManager} from "./js/services/telemetry/Manager";
export {default as UserManager} from "./js/services/users/Manager";
export {default as XDRManager} from "./js/services/xdr/XDRManager";

// Service Utils
export {default as QueryWriter} from "./js/services/gql/QueryWriter";

// Contexts
export {
  StateContext,
  StateProvider,
  withContext as withStateContext
} from "./js/context/StateContext";

// Hooks
export * from "./js/utils/hooks";
export {hooks};

// Utils

const strings = {...stringsImport, ...date}; // backward compatibility

export {auth};
export {date};
export {strings};
export {utils};
export {common};
export {serviceUtils};
export {default as DispositionCache} from "./js/services/disposition/DispositionCache";
